export const DESKTOP_PLATFORM = 'desktop';
export const IOS_PLATFORM = 'ios';
export const ANDROID_PLATFORM = 'android';
export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';